export enum DefaultSortTime {
    CREATED_DATE = 'createdDate',
    APPROVED_DATE = 'approvedDate',
    REJECTED_DATE = 'rejectedDate',
    CANCELED_DATE = 'canceledDate',
    ID = 'id',
  }
  